
import { ComplianceMetric } from './ComplianceMetrics';
import { Policy } from './GovernancePolicies';
import { NonCompliantGroup } from './NonCompliantGroups';

// Sample compliance metrics
export const complianceMetrics: ComplianceMetric[] = [
  { name: 'External Sharing', score: 85, status: 'passing' },
  { name: 'Guest Access', score: 92, status: 'passing' },
  { name: 'Inactive Teams', score: 65, status: 'warning' },
  { name: 'Naming Conventions', score: 70, status: 'warning' },
  { name: 'Owner Requirements', score: 95, status: 'passing' },
  { name: 'Sensitivity Labels', score: 50, status: 'failing' },
];

// Sample policies
export const policies: Policy[] = [
  { 
    id: 1, 
    name: 'External Sharing Restrictions', 
    description: 'Limits external sharing to specific domains and requires review', 
    status: 'Active',
    category: 'Security',
    impact: 'High', 
    lastUpdated: '2023-10-15'
  },
  { 
    id: 2, 
    name: 'Inactive Team Auto-Archive', 
    description: 'Archives teams with no activity for 90+ days', 
    status: 'Active',
    category: 'Lifecycle',
    impact: 'Medium', 
    lastUpdated: '2023-09-22'
  },
  { 
    id: 3, 
    name: 'Naming Convention Enforcement', 
    description: 'Enforces organizational naming patterns for new teams', 
    status: 'Active',
    category: 'Governance',
    impact: 'Low', 
    lastUpdated: '2023-11-05'
  },
  { 
    id: 4, 
    name: 'Guest Access Review', 
    description: 'Requires periodic review of external guests', 
    status: 'Inactive',
    category: 'Security',
    impact: 'High', 
    lastUpdated: '2023-08-17'
  },
  { 
    id: 5, 
    name: 'Sensitive Data Protection', 
    description: 'Applies DLP policies to teams with financial data', 
    status: 'Draft',
    category: 'Compliance',
    impact: 'High', 
    lastUpdated: '2023-10-30'
  },
];

// Sample non-compliant groups
export const nonCompliantGroups: NonCompliantGroup[] = [
  { 
    id: 1, 
    name: 'Marketing Campaign Team', 
    owner: 'Sarah Johnson', 
    violations: ['External Sharing', 'Guest Access'],
    severity: 'High',
    created: '2023-05-12',
  },
  { 
    id: 2, 
    name: 'Product Development', 
    owner: 'Michael Chen', 
    violations: ['Inactive'],
    severity: 'Medium',
    created: '2022-11-23',
  },
  { 
    id: 3, 
    name: 'Finance Department', 
    owner: 'Jessica Miller', 
    violations: ['Naming Convention'],
    severity: 'Low',
    created: '2023-02-08',
  },
  { 
    id: 4, 
    name: 'Executive Discussion', 
    owner: 'Robert Williams', 
    violations: ['Sensitivity Labels', 'External Sharing'],
    severity: 'Critical',
    created: '2023-07-19',
  },
];
